import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/storeExports'
import {
  selectSessionExpirationTime,
  selectHasShownExpirationPopup,
  AuthenticationActions,
  logOutUser,
} from '../../shared/redux/authentication/authenticationSlice'

const EXPIRATION_THRESHOLD_SECONDS = 5 * 60 // 5 minutes

export const useSessionExpiration = () => {
  const dispatch = useAppDispatch()
  const expirationTime = useAppSelector(selectSessionExpirationTime)
  const hasShownPopup = useAppSelector(selectHasShownExpirationPopup)
  const [isSessionExpirationModalOpen, setIsSessionExpirationModalOpen] = useState(false)

  useEffect(() => {
    if (!expirationTime) return

    const checkExpiration = () => {
      const currentTime = Math.floor(Date.now() / 1000)
      const timeLeft = (expirationTime as number) - currentTime

      if (timeLeft <= 0) {
        // session already expired
        dispatch(logOutUser())
        return
      }

      if (timeLeft <= EXPIRATION_THRESHOLD_SECONDS && !hasShownPopup) {
        setIsSessionExpirationModalOpen(true)
        dispatch(AuthenticationActions.setHasShownExpirationPopup(true))
      }
    }

    checkExpiration()

    const interval = setInterval(checkExpiration, 30000)

    return () => clearInterval(interval)
  }, [expirationTime, hasShownPopup, dispatch])

  return {
    isSessionExpirationModalOpen,
    closeSessionExpirationModal: () => setIsSessionExpirationModalOpen(false),
  }
}